<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To Mam and Dad, Phyllis and Dessie, and John and Mary who were the best in-laws I could have ever hoped to have. You shaped my world and I truly miss you all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?415cd609